/**
 * Turns a captured signature data URI into raw bytes for upload.
 * Takes the text after the base64 marker, decodes it with atob and maps each character to its
 * char code.
 *
 * @param dataURI - Base64 data URI of the signature image.
 * @returns The decoded image bytes.
 */
export const dataURIToUInt8Array = (dataURI: string) => {
  const BASE64_MARKER = ';base64,';
  const base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
  return Uint8Array.from(atob(dataURI.substring(base64Index)), (c) => c.charCodeAt(0));
};
